import React from "react";
import ZenGanttChart from "../ManagerDashboard/Common/Graph/ZenGanttChart";
import liracrypt from "../Liracrypt/liracrypt";
import SessionError from "../ApiErrorComp/SessionError";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";

class SbPartInpOpWaterfall extends React.Component {
  state = {
    ZenGanttChart:null,
    loading: true,
    loginError: false,
    // lid: "all",
    // selectedMnt: "all",
    dataLoading: false,
  };

  constructor(props) {
    super(props);
    this._isMounted = false;
  }

  componentDidMount() {
    this.props.setPageHeader("Dashboard");
    this._isMounted = true;
    this.fetchTrendData()
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.loginError = false;
  }

  fetchTrendData = (selectedTab) => {
    liracrypt
      // .get("/textapi", {
      //   lid,
      //   mnt,
      //   typ: "MainGraph",
      //   subTyp: selectedTab,
      //   apiName: "SbLineDashbaord",
      // })
      .get("/textapi", this.props.urlData || {})
      .then(({ data }) => {
        const resp = { ...data };
        let respData = {};
        respData["ZenGanttChart"] = resp["data"]["ZenGanttChart"];
        respData["mainData"] = { ...resp };
        this._isMounted &&
          this.setState(
            {
              ...this.state,
              ...respData,
              loading: false,
              dataLoading: false,
            },
            () => {
              // console.log(this.state.dailyTrend);
            }
          );
      })
      .catch((error) => {
        // message.error('ERROR: Unable to save!', 4);
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            this.setState({
              ...this.state,
              loginError: true,
            });
          }
        }
      });
  };

  render() {
    if (this.state.mainData) {
      return (
        <div
              style={{
                borderRadius: "10px",
                background: "#191C24",
                border: "1px solid #3c3e4f",
                margin: "10px 0px 0px 10px",
                height: "450px",
                width: "1000px",
              }}
            >
              <ZenGanttChart
                divId={"ZenGanttChart1"}
                data={this.state.ZenGanttChart.data}
                config={this.state.ZenGanttChart.config}
              />
            </div>
      );
    } else {
      return (
        <>
          {" "}
          <SessionError visible={this.state.loginError} />
          <div className="contentEmpty"></div>
        </>
      );
    }
  }
}
export default SbPartInpOpWaterfall;